import Script from 'next/script';
import Style from './ModalWhatsApp.css';

function ModalWhatsApp() {
  return (
    <>
      <section id="santander-whatsapp">
        <dialog id="modalWpp">
          <button id="closeBtnWpp">
            <svg
              width="14px"
              height="14px"
              viewBox="0 0 14 14"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              // xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <g id="V1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g
                  id="DESK02"
                  transform="translate(-1328.000000, -24.000000)"
                  fill="#767676"
                  fillRule="nonzero"
                >
                  <g id="Icons/16px/Close" transform="translate(1327.999227, 24.002961)">
                    <path
                      d="M0.147401169,0.146613579 C0.3425711,-0.0487407381 0.659153554,-0.0488902118 0.854507871,0.14627972 L7.003,6.29 L13.1470387,0.152202362 C13.320687,-0.0212820214 13.5901205,-0.0404399613 13.7849249,0.0946480817 L13.8541455,0.152536221 C14.0493154,0.347890538 14.0491659,0.664472992 13.8538116,0.859642923 L7.71,6.996 L13.854933,13.1344344 C14.0285813,13.3079188 14.0479937,13.5773341 13.9130896,13.7722659 L13.8552669,13.8415411 C13.660097,14.0368955 13.3435145,14.0370449 13.1481602,13.841875 L7.003,7.702 L0.853386422,13.8477976 C0.679738141,14.021282 0.410304664,14.04044 0.215500283,13.9053519 L0.14627972,13.8474638 C-0.0488902118,13.6521095 -0.0487407381,13.335527 0.146613579,13.1403571 L6.296,6.996 L0.147735027,0.853720281 C-0.025913254,0.680235897 -0.0453256103,0.410820632 0.0895784196,0.215888775 Z"
                      id="Icon"
                    />
                  </g>
                </g>
              </g>
            </svg>
          </button>
          <h2 id="wppModalTitle">
            Quer um atendimento rápido e humanizado? Chame a gente no{' '}
            <a
              target="_blank"
              href="https://www.santander.com.br/hotsite/santanderfinanciamentos/sandbox.html?modal_source=qrcd&redirect=https://api.whatsapp.com/send?phone=551140049090&text=Olá%20Santander%20Financiamentos"
              rel="noopener"
            >
              WhatsApp
              <picture>
                <source type="image/webp" srcSet="assets/home24/icone_wpp_verificacao.webp" />
                <source
                  type="image/png"
                  srcSet="https://cms.santander.com.br/sites/WPS/imagem/img-wpp-verificacao/22-12-06_183705_P_icone_wpp_verificacao.png"
                />
                <img
                  src="https://cms.santander.com.br/sites/WPS/imagem/img-wpp-verificacao/22-12-06_183705_P_icone_wpp_verificacao.png"
                  alt="sinal de verificado"
                  className="verificado"
                />
              </picture>
              {/* <img
                src="https://cms.santander.com.br/sites/WPS/imagem/img-wpp-verificacao/22-12-06_183705_P_icone_wpp_verificacao.png"
                alt="sinal de verificado"
                id="verificado"
              /> */}
            </a>
          </h2>
          <img
            id="wppQRCode"
            src="assets/QrCode_whatsapp_santander_v2.png"
            alt="QR Code whatsapp Santander Financiamentos"
          />
          <div id="listContainer">
            <ul id="chatOptions" className="textModal">
              <li className="listItemWpp">Atendimento humano</li>
              <li className="listItemWpp">Geração de Boletos</li>
              <li className="listItemWpp">Renegociação</li>
              <li className="listItemWpp">Dúvidas sobre Contratos</li>
            </ul>
            <p className="textModal">E muito mais...</p>
          </div>
          <div id="disclaimerModal">
            <div id="disclaimerImageWpp">
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22">
                <path
                  fill="#767676"
                  fillRule="nonzero"
                  d="M11 .167c5.983 0 10.833 4.85 10.833 10.833 0 5.983-4.85 10.833-10.833 10.833C5.017 21.833.167 16.983.167 11 .167 5.017 5.017.167 11 .167Zm0 15.166c-.3 0-.542.243-.542.542v1.083a.542.542 0 0 0 1.084 0v-1.083c0-.3-.243-.542-.542-.542ZM11 4.5c-.3 0-.542.243-.542.542v8.666a.542.542 0 0 0 1.084 0V5.042c0-.3-.243-.542-.542-.542Z"
                />
              </svg>
            </div>
            <div id="textDisclaimerContainer">
              <p className="textDisclaimerWpp">
                A Santander Financiamentos não te envia mensagens sem que você inicie uma conversa.
              </p>
              <p className="textDisclaimerWpp">
                O único número que utilizamos é o <strong>+ 55 11 40049090</strong>, mostrado no
                perfil.
              </p>
            </div>
          </div>
        </dialog>
        <button id="wppBtnDesktop" className="wppBtn" aria-label="WhatsApp">
          <svg
            width="33px"
            height="33px"
            viewBox="0 0 33 33"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            // xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <defs>
              <path
                d="M16.1774364,0 C25.1038432,0 32.353907,7.25006381 32.353907,16.1764706 C32.353907,25.1028774 25.1038432,32.3529412 16.1774364,32.3529412 C13.3724792,32.3529412 10.6774348,31.6355967 8.27976592,30.290598 L1.02805738,32.3229338 C0.419600604,32.4934575 -0.140635979,31.9316549 0.0315855479,31.3236765 L2.07971286,24.093354 C0.724626081,21.7066593 0.000965852185,18.9934543 0.000965852185,16.1764706 C0.000965852185,7.25006381 7.25102966,0 16.1774364,0 Z M16.1774364,1.61764706 C8.14443146,1.61764706 1.61861291,8.14346561 1.61861291,16.1764706 C1.61861291,18.8205219 2.32574632,21.3587587 3.64589488,23.5684023 C3.76011629,23.7595843 3.79045488,23.9894033 3.72975792,24.2036764 L1.98139081,30.3757821 L8.17019785,28.6413309 C8.38224076,28.5819046 8.60934716,28.6115058 8.79907317,28.7232991 C11.0248455,30.0348023 13.5456789,30.7352941 16.1774364,30.7352941 C24.2104414,30.7352941 30.73626,24.2094756 30.73626,16.1764706 C30.73626,8.14346561 24.2104414,1.61764706 16.1774364,1.61764706 Z M12.4188335,6.77729412 C13.418019,6.77729412 14.3129031,7.3997311 14.6570028,8.33442793 L15.3538921,10.2068142 C15.8016142,11.4056331 15.2210591,12.7442809 14.0411352,13.2412197 L12.4367792,13.9161188 C13.7571437,16.1316319 16.2310369,18.6075928 18.4372635,19.9189216 L19.1129811,18.3126201 C19.6097879,17.1330097 20.9484357,16.5524545 22.1464056,16.9998601 L24.0169409,17.6960666 C24.954767,18.0413237 25.5767747,18.9348926 25.5767747,19.9352353 L25.5767747,22.8550882 C25.5767747,24.3581127 24.3589168,25.5759706 22.8558923,25.5759706 C13.9761339,25.5759706 6.77809821,18.3774081 6.77809821,9.49655882 C6.77809821,7.99479608 7.99631216,6.77729412 9.49898056,6.77729412 L12.4188335,6.77729412 Z M12.4188335,8.39494118 L9.49898056,8.39494118 C8.88950233,8.39494118 8.39574526,8.88840966 8.39574526,9.49655882 C8.39574526,17.4840328 14.8695622,23.9583235 22.8558923,23.9583235 C23.465515,23.9583235 23.9591276,23.4647109 23.9591276,22.8550882 L23.9591276,19.9352353 C23.9591276,19.6121702 23.7592092,19.3249698 23.4553791,19.2131104 L21.5812948,18.515588 C21.1963683,18.3718298 20.7644056,18.5591667 20.6039356,18.940184 L19.5832003,21.3666546 C19.4035284,21.793767 18.9024672,21.982923 18.4853651,21.7810994 L18.4319092,21.7552244 C15.4967743,20.3184809 11.9978904,16.8076039 10.5732486,13.86928 C10.3709844,13.4521103 10.5600687,12.9506385 10.9874142,12.7708685 L13.4135712,11.7502652 C13.7949021,11.5896632 13.982239,11.1577005 13.8381642,10.771925 L13.1399589,8.89598977 C13.029339,8.59551144 12.740977,8.39494118 12.4188335,8.39494118 Z"
                id="path-1"
              />
            </defs>
            <g id="V1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
              <g id="DESK01" transform="translate(-1293.000000, -691.000000)">
                <g id="icon-color" transform="translate(1293.210799, 691.211765)">
                  <mask id="mask-2" fill="white">
                    <use xlinkHref="#path-1" />
                  </mask>
                  <use id="Icon-color" fill="#FFFFFF" xlinkHref="#path-1" />
                </g>
              </g>
            </g>
          </svg>
        </button>
        <a
          id="wppBtnMobile"
          className="wppBtn"
          href="https://www.santander.com.br/hotsite/santanderfinanciamentos/sandbox.html?modal_source=dev04_modalwpp-btnmob&redirect=https://api.whatsapp.com/send?phone=551140049090&text=Ol%C3%A1%20Santander%20Financiamentos"
          target="_blank"
          rel="noopener"
        >
          <svg
            width="33px"
            height="33px"
            viewBox="0 0 33 33"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            // xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <defs>
              <path
                d="M16.1774364,0 C25.1038432,0 32.353907,7.25006381 32.353907,16.1764706 C32.353907,25.1028774 25.1038432,32.3529412 16.1774364,32.3529412 C13.3724792,32.3529412 10.6774348,31.6355967 8.27976592,30.290598 L1.02805738,32.3229338 C0.419600604,32.4934575 -0.140635979,31.9316549 0.0315855479,31.3236765 L2.07971286,24.093354 C0.724626081,21.7066593 0.000965852185,18.9934543 0.000965852185,16.1764706 C0.000965852185,7.25006381 7.25102966,0 16.1774364,0 Z M16.1774364,1.61764706 C8.14443146,1.61764706 1.61861291,8.14346561 1.61861291,16.1764706 C1.61861291,18.8205219 2.32574632,21.3587587 3.64589488,23.5684023 C3.76011629,23.7595843 3.79045488,23.9894033 3.72975792,24.2036764 L1.98139081,30.3757821 L8.17019785,28.6413309 C8.38224076,28.5819046 8.60934716,28.6115058 8.79907317,28.7232991 C11.0248455,30.0348023 13.5456789,30.7352941 16.1774364,30.7352941 C24.2104414,30.7352941 30.73626,24.2094756 30.73626,16.1764706 C30.73626,8.14346561 24.2104414,1.61764706 16.1774364,1.61764706 Z M12.4188335,6.77729412 C13.418019,6.77729412 14.3129031,7.3997311 14.6570028,8.33442793 L15.3538921,10.2068142 C15.8016142,11.4056331 15.2210591,12.7442809 14.0411352,13.2412197 L12.4367792,13.9161188 C13.7571437,16.1316319 16.2310369,18.6075928 18.4372635,19.9189216 L19.1129811,18.3126201 C19.6097879,17.1330097 20.9484357,16.5524545 22.1464056,16.9998601 L24.0169409,17.6960666 C24.954767,18.0413237 25.5767747,18.9348926 25.5767747,19.9352353 L25.5767747,22.8550882 C25.5767747,24.3581127 24.3589168,25.5759706 22.8558923,25.5759706 C13.9761339,25.5759706 6.77809821,18.3774081 6.77809821,9.49655882 C6.77809821,7.99479608 7.99631216,6.77729412 9.49898056,6.77729412 L12.4188335,6.77729412 Z M12.4188335,8.39494118 L9.49898056,8.39494118 C8.88950233,8.39494118 8.39574526,8.88840966 8.39574526,9.49655882 C8.39574526,17.4840328 14.8695622,23.9583235 22.8558923,23.9583235 C23.465515,23.9583235 23.9591276,23.4647109 23.9591276,22.8550882 L23.9591276,19.9352353 C23.9591276,19.6121702 23.7592092,19.3249698 23.4553791,19.2131104 L21.5812948,18.515588 C21.1963683,18.3718298 20.7644056,18.5591667 20.6039356,18.940184 L19.5832003,21.3666546 C19.4035284,21.793767 18.9024672,21.982923 18.4853651,21.7810994 L18.4319092,21.7552244 C15.4967743,20.3184809 11.9978904,16.8076039 10.5732486,13.86928 C10.3709844,13.4521103 10.5600687,12.9506385 10.9874142,12.7708685 L13.4135712,11.7502652 C13.7949021,11.5896632 13.982239,11.1577005 13.8381642,10.771925 L13.1399589,8.89598977 C13.029339,8.59551144 12.740977,8.39494118 12.4188335,8.39494118 Z"
                id="path-1"
              />
            </defs>
            <g id="V1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
              <g id="DESK01" transform="translate(-1293.000000, -691.000000)">
                <g id="icon-color" transform="translate(1293.210799, 691.211765)">
                  <mask id="mask-2" fill="white">
                    <use xlinkHref="#path-1" />
                  </mask>
                  <use id="Icon-color" fill="#FFFFFF" xlinkHref="#path-1" />
                </g>
              </g>
            </g>
          </svg>
        </a>
      </section>
      <style jsx>{Style}</style>
      <Script
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
          //Modal WhatsApp
          (function(){
            const wppBtn = document.querySelector('#wppBtnDesktop')
            const modal = document.querySelector('#modalWpp')
            const closeBtn = document.querySelector('#closeBtnWpp')
            wppBtn.addEventListener('click', ()=>{document.querySelector('#modalWpp').showModal()})
            modal.addEventListener('click', (event)=> {
                var rect = modal.getBoundingClientRect()
                var isInModal=(rect.top <= event.clientY && event.clientY <= rect.top + rect.height
                  && rect.left <= event.clientX && event.clientX <= rect.left + rect.width)
                if (!isInModal) 
                  modal.close()
            }) 
            closeBtn.addEventListener('click', ()=>{document.querySelector('#modalWpp').close()})
          })()
        `,
        }}
      />
    </>
  );
}

export default ModalWhatsApp;
